import React, { useState, useEffect } from 'react';
import Items_From_Cart from './Items_From_Cart';
import CartSummary from './CartSummary';
import { useThemeColors } from '../hooks/useThemeColors';

function CartItemsDetails({ darkMode }) {
  const { themeBg, textColor, isDark } = useThemeColors(darkMode);

  const [showBucketDetails, setShowBucketDetails] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="checkout-page-wrapper"
      style={{
        backgroundColor: themeBg, // Full page background
        minHeight: '100vh',
        transition: 'all 0.3s ease',
        paddingTop: '20px',
      }}
    >
      <div className="container pb-5">
        <h2
          className="mb-4 fw-bold px-2"
          style={{
            color: textColor,
            letterSpacing: '-1px',
          }}
        >
          Checkout Details
        </h2>

        <div className="row g-4">
          <div className="col-lg-8 order-2 order-lg-1">
            <Items_From_Cart
              darkMode={isDark}
              setShowBucketDetails={setShowBucketDetails}
            />
          </div>

          <div className="col-lg-4 order-1 order-lg-2">
            <CartSummary
              showBucketDetails={showBucketDetails}
              setShowBucketDetails={setShowBucketDetails}
              darkMode={isDark}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartItemsDetails;
